import { useParams, useNavigate } from "react-router-dom";
import { AdminPageHeader } from "@/client/components/admin/AdminPageHeader";
import { ActivityEditForm } from "@/client/components/admin/ActivityEditForm";

/**
 * Fallback full-page editor at /admin/programmes/:id/edit. The primary UX is the dialog
 * opened from the Aanbod list (ActivityEditDialog); this page wrapper keeps old/bookmarked
 * links working. It renders the exact same ActivityEditForm; "Sluiten" navigates back to
 * the Aanbod list.
 */
export function ActivityEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const back = () => navigate("/admin/aanbod");

  if (!id) {
    return <p className="text-sm text-destructive">Geen activiteit opgegeven.</p>;
  }

  return (
    <div className="mx-auto max-w-3xl space-y-5 pb-24">
      <AdminPageHeader
        items={[{ label: "Aanbod", to: "/admin/aanbod" }, { label: "Activiteit bewerken" }]}
        subtitle="Pas hier de volledige configuratie van deze activiteit aan. Alle velden zijn vooraf ingevuld."
      />
      <ActivityEditForm programmeId={id} onClose={back} />
    </div>
  );
}
